import { render, staticRenderFns } from "./CollapseMenuV2.vue?vue&type=template&id=6e8a43e6"
import script from "./CollapseMenuV2.vue?vue&type=script&lang=js"
export * from "./CollapseMenuV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports